import { useContext, useEffect, useRef, useState } from "react"
import { deleteAPI, getAPI } from "../api/api"
import { PagePagination } from "../molecule/PagePagination"
import { HorizontalLayout, VerticalLayout } from "./layout"
import { minutesInHour, set } from "date-fns"
import { borderRadius, borderStyle } from "polished"
import { ButtonGroup, ButtonGroupX, StandardButton } from "../atoms/buttons"
import { Modal, ModalBody, ModalTitle } from "./modal"
import { icon } from "../functions/icons"
import { Chip } from "../molecule/Chip"
import { AILeadModal } from "./aiLeadModal"
import { PageContext } from "../App"
import { CompanyDropdown } from "./companyDropdown"
import { time } from "framer-motion"
import { ca } from "date-fns/locale"

export const CompanyComp = ({ companyData, loadLeadsData }) => {

    return (
        <CompanyList loadLeadsData={loadLeadsData} companyData={companyData} />
    )


}

const CompanyList = ({ companyData, loadLeadsData }) => {
    console.log("company data in comp", companyData)
   
    const navigationContext = useContext(PageContext)
     const [currentPages, setCurrentPages] = useState(navigationContext.sidebar?.last_current_page || {});
    const itemsPerPage = 8;
    const endNumber = (currentPages + 1) * itemsPerPage;
    const [activeCompanyId, setActiveCompanyId] = useState(navigationContext.sidebar?.last_id_company)
    const [open, setOpen] = useState(navigationContext.sidebar?.last_category);
    const onToggleCompany = (companyId) => {
        setActiveCompanyId(prev => prev === companyId ? null : companyId)
        navigationContext.handleNavigation({...navigationContext.sidebar, 'last_id_company':companyId})
    }
    const onToggle = (index) => {
        setOpen(prev => prev === index ? null : index)
      
        navigationContext.handleNavigation({...navigationContext.sidebar, 'last_category':(open != index) ? index:null, last_id_company:null, last_current_page:{}})
        setTimeout(() => {
            scrollToCategory(index)
           
        }, 500);
    }

    const categoryRefs = useRef({});

    const scrollToCategory = (index) => {
        const categoryElement = categoryRefs.current[index];
        if (categoryElement) {
            categoryElement.scrollIntoView({ behavior: "smooth", block: "start"});
            
        }
    };
    useEffect(() => {
        if(navigationContext.sidebar?.last_category){
            setTimeout(() => {  scrollToCategory(navigationContext.sidebar.last_category)}, 500);
          
        }
    }, [])
   

    return (
       companyData.map((categories, index) => {
            const currentPage = currentPages[index] || 0;
            return (
                <CompanyDropdown
                    ref={el => categoryRefs.current[index] = el}
                    open={open === index} 
                    toggleOpen={() => onToggle(index)}
                    key={index}
                    title={categories.categorie_name}
                    orgNum={categories.companies.length}
                    sector={categories.sector_name}
                >
                    <VerticalLayout
                        className="company-list-container"
                        style={{
                            overflow: "hidden",

                            height: "fit-content",
                            width: "unset",
                            minHeight: "35.5rem",
                        }} >
                        {categories.companies.slice(currentPage * itemsPerPage, currentPage * itemsPerPage + itemsPerPage).map((lead) => (
                                <Company
                                    loadLeadsData={loadLeadsData}
                                    key={lead.id_lead_company}
                                    company={lead}
                                    isActive={activeCompanyId === lead.id_lead_company}
                                    onToggle={() => onToggleCompany(lead.id_lead_company)}
                                />
                            ))}
                        <PagePagination
                            fixed={true}
                            itemsPerPage={itemsPerPage}
                            onPageChange={(value) =>
                                {setCurrentPages(prev => ({ ...prev, [index]: value }))
                                navigationContext.handleNavigation({...navigationContext.sidebar, last_current_page:{[index]:value}})
                                }
                            }
                            currentPage={currentPages[index] || 0}
                            totalUnits={categories.companies.length}
                            unitName="organisaties"
                        />
                    </VerticalLayout>
                </CompanyDropdown>
            );
        })
    )
}

const Company = ({ company, loadLeadsData, isActive, onToggle }) => {
    const [actionStatus, setActionStatus] = useState('')
    const navigationContext = useContext(PageContext);

    const handleAction = (action) => {
        if (action === "go_to_company_info") {
            navigationContext.handleNavigation({ ...navigationContext.sidebar, navigation: 19, id_lead_company: company.id_lead_company, back_page: 20,id_lead:null, info_complete: company.info_complete });
        }
        setActionStatus(action)
    }
    const removeCompany = async () => {
        const query = "api/leads/company/remove"
        const body = { 'id_lead_company': company.id_lead_company }
        const removed = await deleteAPI(query, body)
        if (removed.status === "ok") {
            setActionStatus('')
            loadLeadsData()
        }
    }
    return (
        <div className={`employee-comp ${isActive && 'active-company'}`} onClick={onToggle} >
            <CompanyRow
                company={company}
                activeCompany={isActive}
            />
            <Status active={company.empty_search} />
            <CompanyActions handleAction={(action) => handleAction(action)} />
            <RemoveCompanyModal
                deleteModalVisible={actionStatus === "delete"}
                setDeleteModalVisible={() => setActionStatus('')}
                data={company}
                keyName={"name"}
                deleteNow={removeCompany}
            />
            <AILeadModal
                mode={true}
                visible={actionStatus === "lead_search"}
                dismiss={() => setActionStatus('')}
                finished={loadLeadsData}
                extraData={company}
            />
        </div>
    )
}
const CompanyRow = ({ activeCompany, company }) => {
    return (<>
        <div style={{ "marginBottom": "auto" }}>
            <img className="rounded-img" src={`https://ui-avatars.com/api/?name=${encodeURIComponent(company.name)}&background=random&color=fffff1&format=svg`} alt={`${company.name} profile avatar`} />
        </div>
        <div className="company-row" style={{ flexGrow: 1 }}>
            <p className={`employee-name`} style={{ "display": "flex", gap: "0.5rem" }}>{company.name}</p>
            <HorizontalLayout style={{ alignItems: "center" }}> <p className={`employee-email`}>{company.description}</p>   <p className={`employee-email `}>• {company.lead_total} leads</p></HorizontalLayout>
            {activeCompany && <LeadsModule
                company={company}
            />}

        </div>
    </>
    )
}

const CompanyActions = ({ handleAction }) => {
    return (
        <ButtonGroupX
            size={"company-actions"}
            buttons={[{
                id: "search",
                action: "lead_search",
                content: <>{icon("lead_search")}</>,
            },
            {
                id: "info",
                action: "go_to_company_info",
                content: <>{icon("info")}</>,
            },
            {
                id: "remove01",
                action: "delete",
                content: <>{icon("trash")}</>,
            }]}
            onClick={(action) => handleAction(action)}
        />
    )
}

const Status = ({ active }) => {
    return (
        active === 1 &&
        <Chip
            classes={2}
            style={{ backgroundColor: "var(--warning-600)", color: "white" }}
            iconStart={"lead_question"}

        />
    )
}

export const RemoveCompanyModal = ({ setDeleteModalVisible, deleteModalVisible, data, keyName, deleteNow }) => {
    return (
        <Modal
            dismissable={setDeleteModalVisible}
            visible={deleteModalVisible}
            size="small"
            content={
                <>
                    <ModalTitle
                        dismissable={setDeleteModalVisible}
                        hasXmark={true}
                        title={`Organisatie verwijderen`}
                    />
                    <ModalBody
                        style={{ maxWidth: "400px" }}
                        content={
                            <>
                                <p className="standard-margin-bottom">
                                    Weet u zeker dat u <b>{data[keyName]}</b> wilt
                                    verwijderen? Alle gegevens zullen verloren gaan.
                                    Deze actie kan niet ongedaan worden gemaakt.
                                </p>
                                <HorizontalLayout
                                    style={{ justifyContent: "flex-end", gap: "1rem" }}
                                >
                                    <StandardButton
                                        className="secondary-button"
                                        style={{ marginLeft: "0px" }}
                                        title="Nee, toch niet"
                                        onClick={setDeleteModalVisible}
                                    />
                                    <StandardButton
                                        style={{ marginLeft: "0px" }}
                                        backgroundColor="error-600"
                                        title="Ja, verwijder"
                                        onClick={deleteNow}
                                    />
                                </HorizontalLayout>
                            </>
                        }
                    />
                </>
            }
        />
    )
}

export const LeadsModule = ({ company }) => {
    const [leadsData, setLeadsData] = useState([])
    const navigationContext = useContext(PageContext);
    useEffect(() => {
        loadLeadsData()
    }, [])
    const loadLeadsData = async () => {
        const query = `api/leads/companies/${company.id_lead_company}/leads`
        const leadsData = await getAPI(query)
        setLeadsData(leadsData.data)
    }
    const handleGoToLead = (id_lead,info) => {
        navigationContext.handleNavigation({ ...navigationContext.sidebar, navigation: 19, id_lead: id_lead, back_page: 20, id_lead_company: null, info_complete: info });
    }
    return (
        <VerticalLayout style={{ gap: "0.5rem", marginTop: "0.5rem" }}>
            {leadsData.map((lead, index) => (
                <HorizontalLayout onClick={(event) => {event.stopPropagation(); handleGoToLead(lead.id_lead, lead.info_complete)}} key={lead.id_lead} style={{ alignItems: "center", gap: "0.5rem", backgroundColor: "var(--primary-50)", padding: "0.25rem 0.5rem", borderRadius: "0.375rem", width: "unset", cursor: "pointer" }}>
                    <img className="rounded-img" src={lead.avatar_url ? lead.avatar_url : `https://ui-avatars.com/api/?name=${encodeURIComponent(lead.first_name + " " + lead.last_name)}&background=random&color=fff&format=svg`} alt={`${lead.first_name} ${lead.last_name} profile avatar`} style={{ width: "24px", height: "24px" }} />
                    <p style={{ color: "black" }} className={`employee-email`}>{lead.first_name} {lead.last_name} • {lead.work_title}</p>

                </HorizontalLayout>
            ))}


        </VerticalLayout>

    )
}
